/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */
import produce from 'immer';
import moment from 'moment';
import { Reducer } from 'redux';

import { ECalendarPeriod } from '@modules/internationalization/types/common/calendar';
import { WIZARD_STORAGE_CLEAR_STEPS } from '@modules/wizard/wizardConstants';
import { EFormatData } from '@pages/PageDashboard/types/widgetTypes';

import { IEditableId, TWizardAdditionalReportsActions } from './types/wizardAdditionalReportsActionTypes';
import {
    EWizardAdditionalReports,
    WIZARD_ADDITIONAL_REPORTS_SET_PARAMS,
    WIZARD_ADDITIONAL_REPORTS_VALIDATE_FINISH,
    WIZARD_ADDITIONAL_REPORTS_VALIDATE_START,
} from './wizardAdditionalReportsConsant';

export interface IWizardAdditionalReportsReducer {
    isStepValid: boolean;
    error: string;
    // 1 step
    chosenReport: EWizardAdditionalReports;
    // 2 step
    autoReportDescription: string;
    autoReportHour: number;
    autoReportMinutes: number;
    autoReportMonth: string;
    autoReportType: ECalendarPeriod;
    autoReportWeek: number;
    formatChoose: string;
    isCreateOrderNow: boolean;
    newSubscribersEndDate: string;
    newSubscribersStartDate: string;
    searchValue: string;

    // from backend
    isAutoReportEnabled: boolean;
    formatsAvailable: string[];
    maxAutoReportsCount: number;
    reportsTypes: EWizardAdditionalReports[];
    ids: IEditableId[];
}

export const initialWizardAdditionalReportsState: IWizardAdditionalReportsReducer = {
    error: '',
    isStepValid: true,
    // 1 step
    chosenReport: EWizardAdditionalReports.REPORT_SUBSCRIBERS_WITH_LIMITS,
    // 2 step
    autoReportDescription: '',
    autoReportHour: 0,
    autoReportMinutes: 0,
    autoReportMonth: '',
    autoReportType: ECalendarPeriod.M,
    autoReportWeek: 0,
    formatChoose: '',
    isCreateOrderNow: true,
    newSubscribersEndDate: moment().endOf('date').format(EFormatData.FullDataWithTimeZone),
    newSubscribersStartDate: moment().startOf('month').format(EFormatData.FullDataWithTimeZone),
    searchValue: '',
    // from backend
    isAutoReportEnabled: true,
    formatsAvailable: [],
    maxAutoReportsCount: 0,
    reportsTypes: [],
    ids: [],
}

const wizardAdditionalReportsReducer: Reducer<IWizardAdditionalReportsReducer, TWizardAdditionalReportsActions> =
    (state = initialWizardAdditionalReportsState, action: TWizardAdditionalReportsActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIZARD_ADDITIONAL_REPORTS_VALIDATE_START:
                    break;
                case WIZARD_ADDITIONAL_REPORTS_VALIDATE_FINISH:
                    draft.isStepValid = action.payload.isStepValid;
                    draft.error = action.payload.validateError;
                    break;

                case WIZARD_ADDITIONAL_REPORTS_SET_PARAMS:
                    Object.assign(draft, { ...draft, ...action.payload });
                    break;

                case WIZARD_STORAGE_CLEAR_STEPS:
                    Object.assign(draft, initialWizardAdditionalReportsState);
                    break;
            }
        })

export default wizardAdditionalReportsReducer;
